import { GodziDropResultType, GodziPrizeTierType, GodziSpinType } from '@slot-nx/core'
import { create } from 'zustand'
import { GameResult } from '../../game/model/GameResult'

export interface IGodziStore {
  isShowFreeSpinBtn: boolean
  isIconOpen: boolean
  isShowDashboard: boolean
  effectiveStake: number
  type: GodziDropResultType
  promotionId: number
  prize: number
  payout: number
  gameResultList: GameResult[]
  freeSpinCount: number
  prizeTier: GodziPrizeTierType
  godziSpinType: GodziSpinType
}

export const useGodziDropStore = create<IGodziStore>(_ => ({
  godziSpinType: GodziSpinType.none,
  isShowFreeSpinBtn: false,
  isIconOpen: false,
  isShowDashboard: false,
  effectiveStake: 0,
  type: GodziDropResultType.None,
  promotionId: 0,
  prize: 0,
  payout: 0,
  gameResultList: [],
  freeSpinCount: 0,
  prizeTier: GodziPrizeTierType.Silver,
}))
